import MarkDownRenderer from '../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
# **If Condition**

In this example, we demonstrate how to use an **If Condition** node after a **For Loop**
to control flow execution based on a specific condition.

The condition checks whether the current loop index is equal to **2**.
If the condition evaluates to **true**, the **Posts API** is executed.

![Flow showing If Condition after For Loop](/flows/IfCondition/IfConditionBoard.png)

## **Setting the Loop Index in Flowstore**

After selecting the **For Loop** node, open the *Flow Variables* panel and store the loop index
in a flow variable (for example, **index**).

This variable is then used in the **If Condition** node to evaluate:

\`\`\`
index === 2
\`\`\`

![Setting index value in For Loop node](/flows/IfCondition/IfConditionForLoopIndexset.png)

## **Flow Execution**

As shown below, during runtime the **Posts API** is triggered **only when the loop index is 2**.
This demonstrates how conditional logic can be applied to precisely control which parts of a flow execute.

![Flow execution showing Posts API run only when index is 2](/flows/IfCondition/IfCondtionBoardRun.png)
`;

const IfCondition = () => {
    return (
        <MarkDownRenderer
            title="If Condition"
            markDownText={markdownContent}
        />
    );
};

export default IfCondition;
